import type { ReactNode } from 'react';

type SubTab<T extends string> = {
  id: T;
  label: string;
  badge?: ReactNode;
};

type SubTabsProps<T extends string> = {
  tabs: Array<SubTab<T>>;
  activeTab: T;
  onChange: (id: T) => void;
};

const SubTabs = <T extends string>({ tabs, activeTab, onChange }: SubTabsProps<T>) => {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="subtabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={tab.id === activeTab ? 'subtab active' : 'subtab'}
          onClick={() => onChange(tab.id)}
          role="tab"
          aria-selected={tab.id === activeTab}
        >
          <span>{tab.label}</span>
          {tab.badge != null ? <span className="subtab-badge">{tab.badge}</span> : null}
        </button>
      ))}
    </div>
  );
};

export default SubTabs;
